console.log('test model')
export let leaderlineEnds = {}
export let leaderlineEls = []
